import { AiFillCloseCircle } from "react-icons/ai";
import { useAdmin } from "../../../context/admin";
import Modal from "../../common/Modal";
import Calendar from "../../common/Calendar";
import { useState } from "react";
import GeneralInput from "../../common/GeneralInput";
import { DailyCost } from "../../../types/common.types";
import AdminService from "../../../services/admin.service";

export default function CreateDailyCost() {
    const { setIsCreateDailyCostModalOpen } = useAdmin()
    const [date, setDate] = useState<Date>()
    const [data, setData] = useState<DailyCost>({} as DailyCost)

    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault()
        try {
            if (!date) return
            const payload = {
                ...data,
                incurred_at: date
            }
            const response = await AdminService.createDailyCost(payload)
            window.location.reload()
        } catch (error) {
            console.log(error)
        }
    }
    return (
        <Modal
        >
            <h1>
                Create Daily Cost
            </h1>
            <Calendar 
            selectedDay={date}
            selectPastDays
            setSelectedDay={setDate}
            />
            <GeneralInput
            name="name"
            label="Name"
            type="text"
            value={data.name || ''}
            onChange={(e) => setData({...data, name: e.target.value})}
            style={{margin: '10px 0'}}
            />
            <GeneralInput
            name="amount"
            label="Amount"
            type="number"
            style={{marginBottom: '10px'}}
            value={data.amount || ''}
            onChange={(e) => setData({...data, amount: Number(e.target.value)})}
            />
            <div className="actions">
                <button 
                onClick={handleSubmit}
                >
                    Create
                </button>
            </div>
            <div className="close"
            onClick={() => setIsCreateDailyCostModalOpen(false)}
            >
                <AiFillCloseCircle/>
            </div>
        </Modal>
    )
}